export default __webpack_public_path__ + "static/media/images/Menu/SET_TITLE_SKIP.webp";